import { useSelector } from 'react-redux';
import { FunctionComponent, useEffect } from 'react';

import { Dsp } from 'components/common/types/Deal.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { getDsps } from 'store/publisher/selectors';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterDspProps } from './FilterDsp.types';

const FilterDsp: FunctionComponent<FilterDspProps> = ({
  dataTestId = 'dsp-filter',
  isDisabled = false,
  selectedValue,
  placeholder = 'Select DSP',
  onChange,
  theme,
  size,
  padding,
  shadow,
  shape,
}) => {
  const dsps = useSelector(getDsps);

  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  const loadDSPData = (_dropdownName?: string, qry?: string): Dsp[] => {
    const dspsResult = qry ? dsps.filter((dsp) => dsp.name.toLowerCase().indexOf(qry.toLowerCase()) > -1) : dsps;
    return dspsResult.sort((dspA, dspB) => dspA.name.toLowerCase().localeCompare(dspB.name.toLowerCase()));
  };

  useEffect(() => {
    loadDSPData();
  }, []);

  return (
    <AsyncSelect
      dataTestId={dataTestId}
      name="dsp"
      loadData={loadDSPData as AsyncSelectLoadDataHandler<Dsp>}
      defaultOptions={dsps}
      onSelect={onChange}
      placeholder={placeholder}
      selectedValue={selectedValue && selectedValue.code ? selectedValue : null}
      isDisabled={isDisabled}
      debounceTime={0}
      theme={theme}
      size={size}
      padding={padding}
      shadow={shadow}
      shape={shape}
      dataPendoId={getPendoDataId('DSP filter')}
    />
  );
};

export default FilterDsp;
